import { elementOrder, categoryOrder } from './constants'
import {
  categoryElementsSelector as categorySelector,
} from 'containers/Form/selectors'
import { createSelector } from 'reselect'

const categoryElementsSelector = categorySelector(
  categoryOrder,
  elementOrder
)

const dialogPageSelector = (state) => state.projectForm.projectImport.dialogPage
const projectListSelector = (state) => state.projectForm.projectImport.projectList
const projectSelectedSelector = (state) => state.projectForm.projectImport.projectSelected

const dialogActiveSelector = createSelector(
  dialogPageSelector,
  (pageNum) => pageNum !== 0
)

const projectListDropdownSelector = createSelector(
  projectListSelector,
  (projectList) => projectList.map(({ id, name: projectName, brand, sku, partnerSite }) => ({
    value: id,
    label: `${id} (${projectName} - ${sku} - ${brand} - ${partnerSite})`,
    projectName,
    sku,
    brand,
    partnerSite
  }))
)

export {
  categoryElementsSelector,
  dialogActiveSelector,
  dialogPageSelector,
  projectListSelector,
  projectListDropdownSelector,
  projectSelectedSelector
}